import React, { Component } from 'react'
// import {
//     Button
// } from 'reactstrap'
import { Icon } from 'react-icons-kit'
import { whatsapp } from 'react-icons-kit/icomoon/whatsapp'
import { animations } from 'react-animation'
import InfoEmpresaObj from '../../utils/empresa'
const empresa = new InfoEmpresaObj()

///https://brandcolors.net/b/whatsapp

export default class WhatsappButton extends Component {
    constructor(props) {
        super(props)

        this.state = {
            infoEmpresa: {}
        }
    }

    formatTel(txt = '') {
        if (txt.length > 1) {
            return txt.substr(1)
        }
    }

    componentWillMount() {
        const _this = this
        empresa.getInfoEmpresa().then(infoEmpresa => {
            _this.setState({
                infoEmpresa
            })
        })
    }

    render() {
        return (
            <a style={{ animation: animations.popIn }} target="_blank" className="btn WhatsappButtonFixed" href={`https://api.whatsapp.com/send?phone=+598${this.formatTel(this.state.infoEmpresa.Telefono)}&text=Hola!`}>
                <Icon className="WhatsappButtonFixedIcon" size={42} icon={whatsapp} />
            </a>
        )
    }
}
